module.exports = __webpack_public_path__ + "img/icon-navigate-circle.4ad2bd39.svg";